import styled from "styled-components";
import {ClockComponentBox} from "../../../../../clock/boxes/clock.component.box";

export const GamePcHeaderBarClockBox = styled(ClockComponentBox)`
    color: ${props => props.theme.colors.textLight};
`